import dynamic from "next/dynamic";

export const Error = dynamic(() => import("./component"));
